/// <reference path="./global.d.ts" />
/*!
 * @preserve
 * Detect.js
 * BrowserInfoCollector Frontend JS for dein-ip-check.de (Modul: detectGeo)
 *
 * @version 3.1.6
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import {detectGeo_Location, detectGeo_Map} from "./lib/detectGeo.library";
import {detectGeo_Whois} from "./lib/detectWhois.library";

// Listener angelegt, da mehrere "OnLoad"-Events existieren
export default function detectGeo() {
    /*
    * Karte initialisieren
    */
    detectGeo_Map.initMap();

    /*
     * IPv4/IPv6-Adressen aktualisieren
     */
    detectGeo_Location.updateIPv4();
    detectGeo_Location.updateIPv6();

    /*
     * IPv4-/IPv6 Whois anlegen
     */
    detectGeo_Whois.initWhoisIPv4("#ipv4whois");
    detectGeo_Whois.initWhoisIPv6("#ipv6whois");
    detectGeo_Whois.initClipboard();

    /*
     * Refresh via JS initialisieren
     */
    $("#refreshPosition").on('click', function(event) {
        event.preventDefault();
        $("#refreshPosition").addClass('disabled');
        $("#browserGeoInfoMessage").show().html(
            `<div id="browserGeoAlert" class="alert-success alert"><button type="button" class="close" data-dismiss="alert">×</button> ${DETECTPHRASE["Position wird bestimmt"]} - ${DETECTPHRASE["bitte warten"]}.</div>`
        );

        navigator.geolocation.getCurrentPosition(detectGeo_Location.showGeoPosition, detectGeo_Location.showGeoError, {
            enableHighAccuracy: false,
            timeout: 30000
        });

        return false;
    });
}
